var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgSortAsc = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#323232",
  d: "M8.62 15.5h6.76L12 18.88 8.62 15.5ZM5 14l7 7 7-7H5Zm0-4h14l-7-7-7 7Z"
})));
export { SvgSortAsc as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTguNjIgMTUuNUgxNS4zOEwxMiAxOC44OEw4LjYyIDE1LjVaTTUgMTRMMTIgMjFMMTkgMTRINVpNNSAxMEgxOUwxMiAzTDUgMTBaIiBmaWxsPSIjMzIzMjMyIi8+Cjwvc3ZnPgo=";